<template>
  <div class="chat-con">
    <div class="chat-head">客服</div>
    <div class="text-content" id="chatCont" ref="chatCont">
      <!-- <v-infinite-scroll :loading="loading" @top="prevPage" @bottom="nextPage" :offset='30' style="max-height: 80vh; overflow-y: scroll;"> -->
      <div class="text-box">
          <div v-for="(item,index) in convContent" :key="index+'a'" class="text-row">
            <div v-if="item.type!=0" class="customer-text">
              <p class="text-speaker">花点时间 </p>
              <div v-if="item.createTime" style="font-size: 12px;color:#98979A">{{ item.createTime }}</div>
              <p v-if="item.contType==1" class="text-cont">
                <img style="width: 200px;height: 200px;" :src="item.content">
              </p>
              <p v-if="item.contType==0" class="text-cont">
                <span v-html="item.content"></span>
                  <span style="display: block;color: #878D99;" v-if="item.refDetail">@{{item.refDetail.speaker}}</span>
                  <span style="display: block;color: #878D99;" v-if="item.refDetail">{{item.refDetail.content}}</span>
                  <span class="top" />
              </p>
            </div>
            <div v-else class="user-text">
              <p class="text-speaker">访客 {{ item.speaker }}
              <span v-if="item.createTime" style="font-size: 12px;color:#98979A">{{ item.createTime }}</span>
              </p>
              <p v-if="item.contType==1" class="text-cont">
                <img :src="item.content" style="width: 200px;height: 200px;">
              </p>
              <p v-else-if="item.contType==0" class="text-cont">
                <span v-html="item.content"></span>
                  <span style="display: block;color: #878D99;" v-if="item.refDetail">@{{item.refDetail.speaker}}</span>
                  <span style="display: block;color: #878D99;" v-if="item.refDetail">{{item.refDetail.content}}</span>
                <span class="bot" />
              </p>
            </div>
            <!-- <div v-else-if="item.type==2" class="system-text">
              <span v-if="item.speaker=='CUST'" class="warn-color">{{ item.content }}</span>
              <span v-else>{{ item.content }}</span>
            </div> -->

          </div>
        </div>
        <!-- </v-infinite-scroll> -->
    </div>
    <div class="send-container" @click.capture="closeEmo">
			<div class="img-container" v-show="showImg">
				<!-- <div class="img-box" id="imgboxid">
					<div class="img-item" v-for="(item,index) in imgArr">
						<span class="del-img" @click="delImg(index)">
								<img src="https://misc.reflower.com.cn/images/customer/delete.png" />
							</span>
						<img :src="item" />
					</div>
				</div> -->
				<input type='file' id="imgInp" @change="upimg($event)" name="imgFile" accept="image/*" style="display: none;" />
			</div>
			<div class="send-box">
        <img class="camera-li" src="../../../static/img/emotion-icon.png" @click.stop="showAllEmo" />
				<img class="camera-li" src="https://misc.reflower.com.cn/images/customer/camera_li.png" @click="checkipt()" />
				<textarea v-model="content" contenteditable placeholder="" ref="textCont" id="textarea"></textarea>
				<div class="send-btn" @click="sendMsg">
					<img src="https://misc.reflower.com.cn/images/customer/reply-send.png" />
				</div>
			</div>
      <div v-show="showEmotion" class="emotion-box clearfix">
        <span v-for="(item,index) in emotionList" :key="index" @click="checkEmo(item)">
          <img :src="item.img" />
        </span>
      </div>
		</div></div>
</template>

<script>
  import {getCookie, delCookie} from "@/utils/cookie"
  import emotion from "@/utils/emotions"
  export default{
    data(){
      return{
        showImg : true,
        imgArr : [],
        content : '',
        emotionList : [],
        showEmotion : false,
        convContent : [],
        page: 1,
        items: [],
        loading: true,
        baseId : '',
        timeringBasId : '',
        showMore : false,
        contTimering : '',
        conId : ''
      }
    },
    created(){
      console.log()
      // this.getUserInfo()
      this.getConv()
      this.emotionList = emotion.emotions
      // this.$once('hook:beforeDestroy', () => {
      //   clearInterval(this.contTimering)
      //   clearInterval(this.timingChatCont)
      // })
    },
    mounted() {
    	jQuery.fn.extend({
    		autoHeight: function() {
    			return this.each(function() {
    				var $this = jQuery(this);
    				if(!$this.attr('_initAdjustHeight')) {
    					$this.attr('_initAdjustHeight', $this.outerHeight());
    				}
    				_adjustH(this).on('input', function() {
    					_adjustH(this);
    				});
    			});
    			/**
    			 * 重置高度
    			 * @param {Object} elem
    			 */
    			function _adjustH(elem) {
    				var $obj = jQuery(elem);
    				return $obj.css({
    						height: $obj.attr('_initAdjustHeight'),
    						'overflow-y': 'hidden'
    					})
    					.height(elem.scrollHeight);
    			}
    		}
    	});
    	// 使用
    	$(function() {
    		$('textarea').autoHeight();
    	});
    },
    methods:{
      prevPage () {
        // this.loading = true
        if (this.page == 1) return
        --this.page

      },
      nextPage () {
        ++this.page

      },
      checkipt: function() {
      	if(this.imgArr.length == 3) {
      		this.popUp('最多上传3张图片！')
      	} else {
      		$('#imgInp').trigger("click");
      		this.showImg = true;
      	}
      },
      checkEmo(item){
        console.log(item)
        this.content = this.content + item.code
        // this.$refs['textCont'].append(item.text)
      },
      showAllEmo(){
        this.showEmotion = true
      },
      closeEmo(){
        this.showEmotion = false
      },
      sendEmotion(){

      },
      getConv(type){
        let uid = getCookie('hdu');
        let formData = new FormData();
        let that = this;
        formData.append('uid',uid)
       const param = {
         uid : uid,
         conId: this.conId,
         baseId: this.baseId
       }
       // if (this.convContent.length >= 10) {
       //   param.more = 1
       // }
       // if (type == 1) {
       //   this.loadMore = true
       // }
       if(!uid){
         return
       }
        this.http({
        	url: this.clientView,
        	method: "get",
        	params: param
        }).then(res => {
        	if(res.data.code == 1) {
            let arr = res.data.data;
            if(arr.length>0){
              if(this.conId == ""){
                this.conId = arr[0].conId

              }
              // if (arr.length == 10) {
              //   this.showMore = true
              //   this.baseId = arr[9].id
              // } else {
              //   this.showMore = false
              // }
             if (arr.length > 0 && param.more == undefined) {
               this.timeringBasId = arr[0].id
               arr.map(item => {
                 item.createTime = this.gmtToStr(item.createTime)
                 if (item.contType == 0) {
                   if(item.content.indexOf('/:')!= -1){
                     emotion.emotions.map(item1 => {
                       console.log(item1.code, 'replacement')
                       console.log(item.content,'regex')
                       let replacement = `<img src="${item1.img}" alt="['${item1.code}']">`
                       // const htmlCon = '<img src=' + item1.img + " align='middle'>"
                       item.content = item.content.replaceAll(item1.code, replacement)
                     })
                   }
                 }
               })
             }
            }
            if (param.more == undefined) {
              this.convContent = arr.reverse()
            } else {
              this.convContent = arr.reverse().concat(this.convContent)
            }
            if (type == 1) {
              this.loadMore = false
            }
            if(this.conId){
              this.contTimering = setInterval(() => {
                that.timingChatCont()
              }, 3000)
            }

        		// this.convContent = arr.reverse()
        	} else {
        		this.popUp(res.data.msg)
        	}

        })
      },
      timingChatCont(type) {
        let uid = getCookie('hdu');
        const param = {
          uid : uid,
          conId: this.conId,
          baseId: this.timeringBasId
        }
       this.http({
       	url: this.clientView,
       	method: "get",
       	params: param
       }).then(res => {
          if (res.data.code == 1) {
            let arr = []
            arr = res.data.data
            if (arr.length != 0) {
              arr.map(item => {
                item.createTime = this.gmtToStr(item.createTime)
                if (item.contType == 0) {
                  if(item.content.indexOf('/:')!= -1){
                    emotion.emotions.map(item1 => {
                      let replacement = `<img src="${item1.img}" alt="['${item1.code}']">`
                      // const htmlCon = '<img src=' + item1.img + " align='middle'>"
                      item.content = item.content.replace(item1.code, replacement)
                    })
                  }
                }
              })
              this.timeringBasId = arr[0].id
            } else {
              // this.showMore = false;
            }
            this.convContent = this.convContent.concat(arr)
            // 去重
            var obj = {}
            this.convContent = this.convContent.reduce(function(item, next) {
              obj[next.id] ? '' : obj[next.id] = true && item.push(next)
              return item
            }, [])
            if (type) {
              this.$nextTick(() => {
                this.$refs['chatCont'].scrollTop = this.$refs['chatCont'].scrollHeight
              })
            }
          }
        })
      },
      compress: function(img, width, height, ratio) {
      	var canvas, ctx, img64;
      	canvas = document.createElement('canvas');
      	canvas.width = width;
      	canvas.height = height;
      	ctx = canvas.getContext("2d");
      	ctx.drawImage(img, 0, 0, width, height);
      	img64 = canvas.toDataURL("image/jpeg", ratio);
      	return img64;
      },
      //tost
      popUp: function(content) {
      	layer.open({
      		content: content,
      		skin: 'msg',
      		time: 2 //2秒后自动关闭
      	});
      },
      getUserInfo: function() {
      	let _this = this;
      	let uid = getCookie('hdu');
      	let hdt = getCookie('hdt');
      	$.ajax({
      		url: _this.userInfo,
      		type: 'post',
      		async: false,
      		type: 'post',
      		xhrFields: {
      			withCredentials: true
      		},
      		contentType: "application/json",
      		crossDomain: true,
      		dataType: "json",
      		success: function(res) {
      			if(res.code == 2000) {
      				_this.user = res.data
      			} else if(res.code == 1010) {
      				delCookie('hdu');
      				delCookie('hdt');
      				if(!uid || !hdt) {
      					_this.$router.push({
      						path: '/'
      					})
      				}

      			} else {
      				// _this.popUp(res.msg)
      			}
      		}
      	});
      },

      //创建回复
      sendMsg: function() {
      	let arr = new Array();
      	// let load = 'https://misc.reflower.com.cn/images/customer/uploading.png';
      	// this.imgArr.map(item => {
      	// 	if(item != load) {
      	// 		arr.push(item)
      	// 	}
      	// });
        let uid = getCookie('hdu');
      	let param = {
      		formId: this.formId,
      		content: this.content,
      		images: JSON.stringify(arr)
      	}
        let formData = new FormData()
        formData.append('msg',this.content)
        formData.append('type',0)
        formData.append('uid',uid)
        formData.append('conId',this.conId)
      	if(this.content == "") {
      		return false
      	} else {
      		this.http({
      			url: this.clientSend,
      			method: "post",
      			data: formData
      		}).then(res => {
      			if(res.data.code == 1) {
      				this.content = "";
              if(this.conId == ''){
                this.getConv()
              }else{
                this.timingChatCont(1)
              }


      			} else {
      				// this.popUp(res.data.msg)
      			}

      		})
      	}

      },
      sendImg(content){
        let uid = getCookie('hdu');
        let formData = new FormData()
        formData.append('msg',content)
        formData.append('type',1)
        formData.append('uid',uid)
        formData.append('conId',this.conId)
        // if(this.content == "") {
        // 	return false
        // } else {
        	this.http({
        		url: this.clientSend,
        		method: "post",
        		data: formData
        	}).then(res => {
        		if(res.data.code == 1) {
        			this.content = "";
              if(this.conId == ''){
                this.getConv()
              }else{
                this.timingChatCont(1)
              }


        		} else {
        			// this.popUp(res.data.msg)
        		}

        	})
        // }

      },
      gmtToStr(time) {
        console.log('time:' + time)
        const date = new Date(time)
        let minutes
        let hours
        let month
        let second
        let relDate
        if (date.getSeconds() < 10) {
          second = '0' + date.getSeconds()
        } else {
          second = date.getSeconds()
        }
        if (date.getMinutes() < 10) {
          minutes = '0' + date.getMinutes()
        } else {
          minutes = date.getMinutes()
        }
        if (date.getHours() < 10) {
          hours = '0' + date.getHours()
        } else {
          hours = date.getHours()
        }
        if (date.getMonth() < 10) {
          month = '0' + (date.getMonth() + 1)
        } else {
          month = date.getMonth()
        }
        if (date.getDate() < 10) {
          relDate = '0' + date.getDate()
        } else {
          relDate = date.getDate()
        }
        const Str = date.getFullYear() + '-' +
            month + '-' +
            relDate + ' ' +
            hours + ':' +
            minutes + ':' +
            second
        return Str // 返回的就是yyyy-MM-dd HH:mm:ss格式，上面time就是你传入的林尼治标准时间
      },

      upimg: function(event) {
      	console.log(event.target.files)
      	var _this = this;
      	var imgurl = this.upload;
      	var iamges = new Array();
      	var file1 = event.target.files;
      	for(var i = 0; i < file1.length; i++) {
      		var file = file1[i];
      		(function(file, i) {
      			var reader = new FileReader();
      			iamges[i] = new Image();
      			reader.readAsDataURL(file);
      			reader.onloadend = function(e) {
      				var ace = this.result;
      				iamges[i].src = ace;
      			};
      			let loStr = 'https://misc.reflower.com.cn/images/customer/uploading.png';
      			_this.imgArr.splice(i, 0, loStr);
      			iamges[i].onload = function() {
      				var w = iamges[i].width;
      				var h = iamges[i].height;
      				var ratio, multiplier;
      				if(w < 720 && h < 720) { //小于100K 的不压缩
      					multiplier = 1;
      					ratio = 0.8;
      				} else {
      					ratio = 1;
      					if(w < 720 && h >= 720) {
      						multiplier = 720 / h;
      					} else if(w >= 720 && h < 720) {
      						multiplier = 720 / w;
      					} else {
      						multiplier = 720 / Math.max(w, h);
      						ratio = 0.8;
      					}
      				}
      				var imageData = _this.compress(iamges[i], w * multiplier, h * multiplier, ratio);
      				var formData = new FormData();
      				formData.append("imageData", imageData);
      				$.ajax({
      					url: imgurl,
      					type: 'POST',
      					cache: false,
      					data: formData,
      					async: false,
      					processData: false,
      					contentType: false,
      					dataType: "json",
      					xhrFields: {
      						withCredentials: true
      					},
      					crossDomain: true,
      					success: function(msg) {
      						console.log(i, 'i')
      						if(msg.code == 1) {
      							var str = 'http://img.reflower.com.cn/' + msg.data;
      							if(_this.imgArr.length <= 3) {

      								_this.imgArr.splice(i, 1);
      								_this.imgArr.push(str);
      							} else {
      								return
      							}
                    _this.sendImg(str)

      							console.log(_this.imgArr, '_this.imgArr')
      						} else {
      							_this.popUp(msg.desc)
      						}

      					}
      				});
      			}
      		})(file, i)

      	}
      },
    }
  }

</script>

<style scoped>
	/*开启用户复制文字*/
	._v-container[data-v-ecaca2b0] {
		webkit-user-select: auto;
		/*webkit浏览器*/
		-khtml-user-select: auto;
		/*早期浏览器*/
		-moz-user-select: auto;
		/*火狐*/
		-ms-user-select: auto;
		/*IE10*/
		user-select: auto;
	}

  .chat-con{
    height: 100vh;
    text-align: left;
  }
  .chat-head{
    height: 0.8rem;
    font-size: 0.4rem;
    line-height: 0.8rem;
    background-color: #fff6ed;
    text-align: center;
  }
  .text-content{
   height: calc(100vh - 1.28rem);
    padding-bottom: 2rem;
    overflow-y: scroll;
  }
  .text-box {
    padding: 0.266666rem 0.266666rem;
  }

  .text-row .text-speaker {
    color: firebrick;
    line-height: 20px;
    font-size: 0.186666rem;
  }
  .text-cont {
    display: inline-block;
    line-height: 20px;
    padding: 0.133333rem 0.266666rem;
    background: #FFFFFF;
    border-radius: 5px;
    position: relative;
    margin-top: 10px;
    font-size: 0.186666rem;

  }
  .text-cont span.bot {
    position: absolute;
    border-width: 10px;
    border-style: solid dashed dashed;
    border-color: transparent transparent #FFFFFF;
    left:15%;
    top: -20px;
  }
  .text-cont span.top {
    position: absolute;
    border-width: 10px;
    border-style: solid dashed dashed;
    border-color: transparent transparent #FFFFFF;
    right: 15%;
    top: -20px;
  }
  .customer-text {
    text-align: left;
  }
  .user-text{
    text-align: right;
  }
  .system-text{
    padding: 20px 0;font-size: 0.186666rem;text-align: center;color: #98979A;line-height: 14px;

  }
  .warn-color{
    color: firebrick;
  }
	.clearfix:after {
		content: ".";
		display: block;
		clear: both;
		visibility: hidden;
		font-size: 0;
	}

	.send-container {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 100%;
	}

	.send-box {
		background-color: #FFFFFF;
		min-height: 1.28rem;
		width: 100%;
		padding: 0.266666rem 0.4rem;
		display: flex;
		display: -webkit-flex;
		align-items: center;
		-webkit-align-items: center;
		/*justify-content: space-between;*/
		flex-direction: row;
		-webkit-flex: row;
		/*-webkit-justify-content: space-between;*/
		border-top: 1px solid #DDDDDD;
		width: 100%;
	}

	.send-box .camera-li {
		width: 0.586666rem;
		margin-right: 0.293333rem;
	}

	.send-box .send-btn {
		margin-left: 0.293333rem;
		/*width: 0.56rem;
		height: 0.426666rem;*/
	}

	.send-box .send-btn img {
		display: block;
		width: 0.56rem;
	}
  .emotion-box span{
    display: inline-block;
    height: 26px;
    line-height: 26px;
    float: left;
  }
	textarea {
		resize: none;
		display: block;
		width: 7rem;
		height: 0.746666rem;
		line-height: 0.533333rem;
		border-color: #CCCCCC;
		outline: none;
		font-size: 0.346666rem;
    border-radius: 0.053333rem;
	}

	textarea::-webkit-input-placeholder {
		color: #999;
	}


	input {
		font-size: 0;
		outline: none;
		border: none;
		display: none;
		opacity: 0;
		background-color: #FFFFFF;
	}

	.user-header {
		border: 1px solid #EBEBEB;
	}

	.no-data {
		height: 1.333333rem;
		width: 100%;
		line-height: 1.333333rem;
		z-index: 0;
		font-size: 0.4rem;
		text-align: center;
		color: #999999;
	}


	.solve-box {
		font-size: 0.373333rem;
		margin-top: 0.64rem;
		padding: 0 0.4rem;
		text-align: left;
		height: 0.533333rem;
	}

	.solve {
		display: inline-block;
		width: 1.866666rem;
		height: 0.533333rem;
		text-indent: 0.666666rem;
		margin-left: 0.8rem;
	}

	.solve-y {
		background: url(https://misc.reflower.com.cn/images/customer/praise_l.png) no-repeat left center;
		background-size: 0.506666rem auto;
	}

	.solve-n {
		background: url(https://misc.reflower.com.cn/images/customer/praise_garyl.png) no-repeat left center;
		background-size: 0.506666rem auto;
	}

	.solve-yc {
		background: url(https://misc.reflower.com.cn/images/customer/praise.png) no-repeat left center;
		background-size: 0.506666rem auto;
		color: #C4D275;
	}

	.solve-nc {
		background: url(https://misc.reflower.com.cn/images/customer/praise_gary.png) no-repeat left center;
		background-size: 0.506666rem auto;
		color: #C4D275;
	}

	.praise-sub {
		margin: 0.693333rem 0.48rem 0 0.48rem;
		height: 1.066666rem;
		line-height: 1.066666rem;
		background-color: #C8D678;
		font-size: 0.48rem;
		color: #FFFFFF;
		border-radius: 0.08rem;
	}

	.praise-done {
		background-color: #FFFFFF;
	}

	.praise-bo {
		border-top: 1px solid #DDDDDD;
		padding-bottom: 0.64rem;
	}

	.explain-wrap {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1000;
	}

	.explain-wrap::before {
		content: '';
		z-index: 0;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #000;
		opacity: 0.7;
	}

	.content-boxb {
		z-index: 3001;
		width: 8.8rem;
		/*height: 12.666666rem;*/
		border-radius: 0.106666rem;
		position: absolute;
		background-color: #fff;
		left: 50%;
		top: 50%;
		-webkit-transform: translate(-50%, -50%);
		-o-transform: translate(-50%, -50%);
		-moz-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	.content-boxb img {
		display: block;
		width: 100%;
		height: 100%;
	}
  .clearfix:after {
  	content: "";
  	height: 0;
  	line-height: 0;
  	display: block;
  	clear: both;
  	visibility: hidden;
  }

  .clearfix {
  	zoom: 1;
  }
</style>



// WEBPACK FOOTER //
// src/path/submenu/chat.vue